module.exports = __webpack_public_path__ + "img/icon_img_04.1202a098.png";